
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogUtilsService } from 'src/app/shared/services';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState, } from '@angular/cdk/layout';
import { isArray } from 'util';

@Component({
    selector: 'app-variations',
    templateUrl: './variations.component.html',
    styleUrls: ['./variations.component.less'],
})
export class VariationsComponent implements OnInit {
    @Output() setImage = new EventEmitter<any>();
    @Output() setPrice = new EventEmitter<any>();
    @Output() reload = new EventEmitter<any>();
    @Output() setSelectionChecked = new EventEmitter<any>();
    @Output() clearSelection = new EventEmitter<any>();
    @Output() setSelection = new EventEmitter<any>();
    @Output() currentFilteredVariations = new EventEmitter<any>();
    @Output() resetSelection = new EventEmitter<any>();
    @Input() urlVariant: string;

    @Input() variations = [];
    @Input() inputSelections = {};
    @Input() isSwatchExist = false;
    @Input() hasSelection = true;

    beforeSelection = false;
    selectedFlag = false;
    bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.Handset
    );
    swatches = []; // This stores all available swatches
    customMadeSwatches = [];
    stockedSwatches = [];
    /**
     * Stores Variations that are filtered by selections.
     * Initally equal to @var variations
     */
    filteredVariations = [];

    swatchFilter = [];
    /**
     * Stores all the selections made by the user in key:value format
     * key is the @string type of filter and value is @array for multi-select and @string for single-select filters
     */
    selections = {};

    selectedIndex: number;

    priceData = {
        price: '',
        wasPrice: '',
    };

    selectionsExist: boolean;
    bpSubscription: Subscription;
    isHandset: boolean;

    selectionOptions = {}; // stores all options available for selections

    // Stores currently selected swatch
    selectedSwatch = {
        image: '',
        swatch_image: null,
        price: '',
        wasPrice: '',
        name: '',
        variation_sku: ''
    };

    previousSwatch;
    selectionAdd = 1;
    selectionRemove = 2;
    currentIndex: number = 1;
    finalInputSelec: any[] = [];

    constructor(
        private router: Router,
        private matDialogUtils: MatDialogUtilsService,
        private breakpointObserver: BreakpointObserver
    ) {
    }

    onBoxScroll(event: WheelEvent) {
        const box = event.currentTarget as HTMLElement;
        const isAtTop = box.scrollTop === 0;
        const isAtBottom = box.scrollTop + box.clientHeight >= box.scrollHeight;

        if ((!isAtTop && event.deltaY < 0) || (!isAtBottom && event.deltaY > 0)) {
            // ✅ Allow box to scroll independently
            event.stopPropagation();
        }
    }

    get isColorExist() {
        return this.finalInputSelec[0]?.value?.options?.length > 0 && this.finalInputSelec[0].key ==='color';

    }

    ngOnInit() {
        this.bpSubscription = this.bpObserver.subscribe(
            (handset: BreakpointState) => {
                this.isHandset = handset.matches;
            }
        );
        this.selectionsExist = true;
        if (this.selectionsExist) {
            let newInputSel = Object.keys(this.inputSelections).reduce((accumulator, currentValue) => {
                //   if (this.inputSelections[currentValue]?.select_type !== 'excluded') {
                accumulator[currentValue] = this.inputSelections[currentValue];
                //   }
                return accumulator;
            }, {});

            let singleSel = 0;

            let keys = Object.keys(newInputSel).filter(f => (f !== 'color_group' || f['color']?.select_type !== 'excluded'));
            keys = keys.sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));
            keys.forEach((key) => {
                if (newInputSel[key].select_type == 'single_select') {
                    singleSel++;
                }
            });
            let newArr = [];
            // tslint:disable-next-line: forin
            for (let i = 0; i < keys.length; i++) {

                if (newInputSel[keys[i]].select_type == 'single_select') {
                    singleSel = singleSel - 1;
                    newInputSel[keys[i]].index = singleSel;
                    if (Object.keys(newInputSel).includes('color_group')) {
                        newInputSel[keys[i]].index =
                            newInputSel[keys[i]].select_type == 'single_select' ? newInputSel[keys[i]].index + 1 :
                                newInputSel[keys[i]].index + 2;
                    } else {
                        newInputSel[keys[i]].index = newInputSel[keys[i]].index + 1;
                    }
                } else {
                    newInputSel[keys[i]].index = 0;
                }

                const value = newInputSel[keys[i]];
                // tslint:disable-next-line: forin
                for (const object in value) {
                    const newObject = JSON.stringify(value[object]);
                    const options = JSON.parse(newObject);
                    if (Array.isArray(options)) {
                        // tslint:disable-next-line: prefer-for-of
                        for (let i = 0; i < options.length; i++) {
                            this.selectionOptions[options[i]] = true;
                        }
                    }
                }
                newArr.push({
                    key: keys[i],
                    index: newInputSel[keys[i]].index,
                    value: newInputSel[keys[i]]
                });
                this.finalInputSelec = newArr.sort((a, b) => a.index - b.index);
            }
        }
        const self = this;
        this.filteredVariations = this.variations;
        this.swatches = this.variations
            .filter((variation) => {
                return variation.swatch_image !== null;
            })
            .filter((variation) => {
                return self.filterDuplicateSwatches(variation, self);
            });
        let countSingleSelect = 0;
        if (this.inputSelections['type'] === 'redirect') {
            this.setSelectionChecked.emit(true);
        } else {
            for (const item in this.inputSelections) {
                this.inputSelections[item].selected = false;
                if (this.inputSelections[item].select_type === 'single_select') {
                    countSingleSelect++;
                }
            }
            if (countSingleSelect === 0) {
                this.setSelectionChecked.emit(true);
            }
        }
        this.groupSwatches();
        console.log(this.swatches, 'dad');
        console.log(this.finalInputSelec, 'FINAL')


        // if(this.urlVariant){ 
        //   let x =  this.swatches.find(f=>f.variation_sku === this.urlVariant);
        //   let ind = this.finalInputSelec[0].value.options.findIndex(f=>f==x.name)
        //   this.selectedVariation(x,ind); 

        //   }
        if (this.urlVariant) {
            let x: any;
            let ind = -1;
            let data: any[];
            if (this.swatches?.length > 0) {
                x = this.swatches.find(f => f.variation_sku === this.urlVariant);
                ind = this.finalInputSelec[0].value.options.findIndex(f => f == x?.name)
            } else {
                x = this.variations.find(f => f.variation_sku === this.urlVariant);
                data = this.finalInputSelec.filter(f => f.value.options && f.value.options.length > 0);
                ind = data[0].value.options.findIndex(f => f == x?.name)
            }
            this.selectedVariation(x, ind);
            // fix Var: 164304-33219736111
         const colorIndex = this.finalInputSelec.findIndex(f=>f.key=='color'
                ||(f.key==="color_group"&&f.value.select_type!=='excluded')
            );
            if(colorIndex>=0 && x.name){
            this.selectedOption(x.name,this.finalInputSelec[colorIndex].key)
            }

        }
    }

    onDestroy(): void {
        this.bpSubscription.unsubscribe();
    }

    /**
     * Sets the current selected variation to the variation passed in param
     * @param variation The variation to be selected
     * @param index Index of the selected variation
     */
    selectedVariation(variation, index: number) {
        // variation.has_parent_sku
        this.selectedSwatch = {
            image: variation.image,
            swatch_image: variation.swatch_image,
            price: variation.price,
            wasPrice: variation.was_price,
            name: variation.name,
            variation_sku: variation.variation_sku
        };
        this.selectedIndex = index;
        this.setImage.emit(variation);

        this.filterSwatches();
        this.updateSwatches();
        this.currentFilteredVariations.emit({ data: this.filteredVariations, current: variation });
        this.setSelectedOptionsOfVariation(variation);
        this.selectionEmit();
    }

    selectionEmit() {
        this.beforeSelection = true;
        this.selectedFlag = false;
        for (const selected in this.inputSelections) {
            if (this.inputSelections[selected].select_type === 'single_select') {
                this.beforeSelection =
                    this.beforeSelection && this.inputSelections[selected].selected;
                this.selectedFlag =
                    this.selectedFlag || this.inputSelections[selected].selected;
            }
        }

        this.setSelectionChecked.emit(this.beforeSelection);
    }

    /**
     * Add or remove a single select option from selections object
     * Then update swatches based on final result
     * @return void
     * @param option
     * @param type
     */
    selectedOption(option: string, type: string) {
        let currentSelIndex = this.inputSelections[type].index;
        for (const key in this.inputSelections) {
            const value = this.inputSelections[key];
            if (value.index > currentSelIndex) {
                this.inputSelections[key].selected = false;
                delete this.selections[key];
                for (const features in value.options) {
                    const feature = value.options[features];
                    this.selectionOptions[feature] = false;
                }
                this.resetSelection.emit(true)
            }

        }

        if (this.selections[type] === option) {
            delete this.selections[type];
            this.inputSelections[type].selected = false;
        } else {
            this.selections[type] = option;
            this.inputSelections[type].selected = true;
        }
        this.selectionEmit();
        this.updateSwatches();
        this.updatePriceBasedOnSelections();
        this.filterVariationsForSingleSelect();


    }

    checkApproximateSwatch(variation, self) {
        let isValidVariation = true;
        for (const key in self.selections) {
            if (this.selectionHasFeature(variation.features, key)) {
                isValidVariation = true;
            } else {
                isValidVariation = false;
                break;
            }
        }
        return isValidVariation;
    }

    /**
     * Set all options available for a particular swatch.
     * Only single-select filters are updated
     * @param variation The variation's swatch image to be used to set the options
     */
    setSelectedOptionsOfVariation(variation: any) {
        // Get all the options belonging to swatch
        const variationOptions = this.variations
            .filter((v) => v.name === variation.name)
            .reduce((acc, { features }) => {
                Object.keys(features).forEach((key) => {
                    if (acc[key]) {
                        if (!acc[key].includes(features[key])) {
                            acc[key].push(features[key]);
                        }
                    } else {
                        acc[key] = [features[key]];
                    }
                });
                return acc;
            }, {});
        let filteredVariations = [];
        Object.keys(variationOptions).forEach(key => {
            const selectionKeys = Object.keys(this.selections);
            const valuesOfVariation = variationOptions[key];
            valuesOfVariation.forEach(option => {
                const intermediate = this.variations
                    .filter(v => v.name === variation.name)
                    .filter(v => {
                        let isValid = true;
                        selectionKeys.forEach(selection => {
                            if (v.features[selection] !== this.selections[selection] || v.features[key] !== option) {
                                isValid = false;
                            }
                        });
                        return isValid;
                    });
                filteredVariations = [...filteredVariations, ...intermediate];
            });
        });
        const newVariationOptions = filteredVariations.reduce((acc, { features }) => {
            Object.keys(features).forEach((key) => {
                if (acc[key]) {
                    if (!acc[key].includes(features[key])) {
                        acc[key].push(features[key]);
                    }
                } else {
                    acc[key] = [features[key]];
                }
            });
            return acc;
        }, {});
        const variationProducts = this.variations.filter(v => v.name === variation.name).filter(v => this.checkSwatchSelection(v, this));
        if (variationProducts.length === 0) {
            this.clearSingleSelections();
        }
        let excludedOptions = [];
        // tslint:disable-next-line:forin
        for (const selection in this.selections) {
            const options = this.inputSelections[selection].options;
            excludedOptions = [...excludedOptions, ...options];
        }
        // Filter @var selectionOptions based on all options
        for (const filter in newVariationOptions) {
            const filterValue = newVariationOptions[filter];

            // tslint:disable-next-line:forin
            if (this.inputSelections[filter].select_type === 'single_select') {
                const options = this.inputSelections[filter].options;
                for (const value of options) {
                    if (!filterValue.includes(value) && !excludedOptions.includes(value)) {
                        this.selectionOptions[value] = false;
                    }
                }
                // if (filterValue.length === 1) {
                //     this.selections[filter] = filterValue[0];
                //     this.inputSelections[filter].selected = true;
                // }
            }
        }
        this.updatePriceBasedOnSelections();

    }

    private updatePriceBasedOnSelections() {
        if (!this.selectedSwatch.swatch_image) {
            return;
        }
        const filteredVariations = this.variations.filter(v =>
            v.swatch_image === this.selectedSwatch.swatch_image &&
            v.image === this.selectedSwatch.image);
        const self = this;
        let minPrice = 0;
        let maxPrice = 0;
        let wasMaxPrice = 0;
        let wasMinPrice = 0;
        filteredVariations.forEach(value => {
            const isValid = this.checkSwatchSelection(value, self);
            if (isValid) {
                if (minPrice && maxPrice) {
                    if (Number(maxPrice) < Number(value.price)) {
                        maxPrice = value.price;
                        wasMaxPrice = value.was_price;
                    }
                    if (Number(minPrice) > Number(value.price)) {
                        minPrice = value.price;
                        wasMinPrice = value.was_price;
                    }

                } else {
                    minPrice = value.price;
                    maxPrice = value.price;
                    wasMaxPrice = value.was_price;
                    wasMinPrice = value.was_price;
                }
            }
        });
        if (maxPrice === minPrice) {
            this.priceData = {
                price: `${minPrice}`,
                wasPrice: `${wasMinPrice}`,
            };
        } else {
            this.priceData = {
                price: `${minPrice} - ${maxPrice}`,
                wasPrice: `${wasMinPrice} -  ${wasMinPrice}`,
            };
        }

        this.setPrice.emit(this.priceData);
    }

    /**
     * Whenever multi-select options are changed this method is called.
     * It either adds the option or removes the option if already present
     * Then updates the swatches based on final result.
     * @param event Event type (checked || unchecked)
     * @param option Option Value in @var this.selectionOptions
     * @param type Type of multi-select Filter
     */
    onCheckChange(event, option: string, type: string) {
        if (event.source.checked) {
            this.addCheckedToMultiSelect(type, option);
            this.selectedFlag = true;
        } else {
            this.removeCheckedFromMultiSelect(type, option);
        }
        this.resetSelectedSwatch();
        this.updateOptions(type, event.source.checked);
        // this.updateSwatches();
    }

    private removeCheckedFromMultiSelect(type: string, option: string) {
        this.selections[type] = this.selections[type].filter(
            (value: string) => value !== option
        );
        if (this.selections[type].length < 1) {
            delete this.selections[type];
            this.enableSelectionsOtherThanType(type);
        }
        const selectionLength = Object.keys(this.selections).length;
        if (selectionLength === 0) {
            this.clearVariations();
        }
    }

    private resetSelectedSwatch() {
        this.selectedSwatch = {
            image: '',
            swatch_image: null,
            price: '',
            wasPrice: '',
            name: '',
            variation_sku: ''
        };
    }

    private addCheckedToMultiSelect(type: string, option: string) {
        if (this.selections[type]) {
            this.selections[type].push(option);
        } else {
            this.selections[type] = [option];
        }
    }

    enableSelectionsOtherThanType(type) {
        for (const key in this.inputSelections) {
            if (key !== type && this.inputSelections[key].select_type === 'multi_select') {
                const options = this.inputSelections[key].options;
                for (const option of options) {
                    this.selectionOptions[option] = true;
                }
            }
        }

    }

    /**
     * Update variations based on values in current selections
     * Valid variations are marked as enabled(true) in @method checkSwatchSelection
     * return filtered variations ie all the variations that were enabled.
     * @returns array filteredVariations
     */
    updateVariationsBasedOnSelections() {
        const self = this;
        this.swatchFilter = [];
        const filteredVariations = this.variations
            .map((variation) => {
                return {
                    ...variation,
                    enabled: this.checkSwatchSelection(variation, self),
                };
            })
            .filter((variation) => {
                if (variation.swatch_image !== null) {
                    return this.filterDuplicateSwatches(variation, self);
                }
            });
        this.swatches = [];
        for (const variation of filteredVariations) {
            if (
                this.swatchFilter.includes(variation.swatch_image) &&
                this.previousSwatch.swatch_image === variation.swatch_image
            ) {
                this.swatches.pop();
            }
            this.swatches.push(variation);
            this.previousSwatch = variation;
        }
        this.groupSwatches();
        return filteredVariations;
    }

    clearSingleSelections() {
        const keys = Object.keys(this.inputSelections).filter(key => this.inputSelections[key].select_type === 'single_select');
        for (const key of keys) {
            this.selections.hasOwnProperty(key);
            {
                delete this.selections[key];
            }
        }
    }

    /**
     * Clears all options in @this.selections and resets all filters.
     */
    clearVariations() {
        this.clearSelection.emit(true);
        this.selections = {};
        this.selectedIndex = null;
        this.setPrice.emit('');
        this.setImage.emit('');
        this.currentFilteredVariations.emit({ data: this.filteredVariations, current: null });

        this.setSelectionChecked.emit(false);
        for (const item in this.inputSelections) {
            this.inputSelections[item].selected = false;
        }
        this.selectionEmit();
        this.selectedSwatch = {
            image: '',
            swatch_image: null,
            price: '',
            wasPrice: '',
            name: '',
            variation_sku: ''
        };
        this.selectedFlag = false;
        // this.beforeSelection = true;
        this.setSelection.emit(true);
        this.filterSwatches();
        this.updateSwatches();
    }

    /**
     * Marks variation as enabled if any one of the feature is present in the selection.
     * @param variation The variation to be marked
     * @param self  The context, If empty takes 'this' as current context
     */
    selectSwatchContainingSelection(variation, self = this): boolean {
        let isValidVariation = true;
        for (const key in self.selections) {
            if (
                variation.features[key] === self.selections[key] ||
                self.selections[key].includes(variation.features[key])
            ) {
                isValidVariation = true;
                break;
            } else {
                isValidVariation = false;
            }
        }
        return isValidVariation;
    }

    /**
     *
     * @param type
     * @param isChecked
     */
    updateOptions(type: string, isChecked) {
        const self = this;
        self.swatchFilter = [];
        const filteredSwatches = ([] = this.variations
            .map((variation) => {
                return {
                    ...variation,
                    enabled: self.checkSwatchSelection(variation, self),
                };
            })
            .filter((variation) => {
                if (variation.swatch_image !== null) {
                    return self.filterDuplicateSwatches(variation, self);
                }
            }));

        this.swatches = [];
        for (const variation of filteredSwatches) {
            if (
                this.swatchFilter.includes(variation.swatch_image) &&
                this.previousSwatch.swatch_image === variation.swatch_image
            ) {
                this.swatches.pop();
            }
            this.swatches.push(variation);
            this.previousSwatch = variation;
        }
        this.groupSwatches();

        if (isChecked) {
            const excludedOptions = this.inputSelections[type].options;
            for (const key in this.selectionOptions) {
                if (excludedOptions.indexOf(key) === -1) {
                    this.selectionOptions[key] = false;
                }
            }
        }
        const filteredVariations = this.variations.filter((v) => {
            const features = v.features;
            let isValidVariation: boolean;
            for (const key in this.selections) {
                if (
                    v.features[key] === this.selections[key] ||
                    this.selections[key].includes(v.features[key])
                ) {
                    isValidVariation = true;
                    break;
                } else {
                    isValidVariation = false;
                }
            }
            return isValidVariation;
        });
        filteredVariations.forEach((variation) => {
            const features = variation.features;
            for (const filter in features) {
                if (filter !== type && filter !== 'color') {
                    const filterValue = features[filter];
                    const options = this.inputSelections[filter].options;
                    for (const option of options) {
                        if (filterValue === option) {
                            this.selectionOptions[option] = true;
                        }
                    }
                }
            }
        });
    }

    /**
     * This method updates which swatches to show based on selections.
     * If swatch is selected
     * @emits setPrice // Set price Event
     * @emits setImage // setImage Event
     */
    updateSwatches() {
        const self = this;
        self.swatchFilter = [];
        const filteredSwatches = ([] = this.variations
            .map((variation) => {
                return {
                    ...variation,
                    enabled: self.checkSwatchSelection(variation, self),
                };
            })
            .filter((variation) => {
                if (variation.swatch_image !== null) {
                    return self.filterDuplicateSwatches(variation, self);
                }
            }));
        if (this.selectedSwatch.swatch_image) {
            const vars = filteredSwatches.filter(v => v.swatch_image === this.selectedSwatch.swatch_image).some(v => v.enabled);
            if (!vars) {
                this.selectedSwatch = {
                    swatch_image: '',
                    name: '',
                    image: '',
                    price: '',
                    wasPrice: '',
                    variation_sku: ''
                };
            }
        }

        // const filteredSwatches = this.variations.map(variation => {
        //     return {
        //         ...variation,
        //         enabled: self.checkSwatchSelection(variation, self)
        //     };
        // }).filter(variation => {
        //    return variation.name === 'Dusty Teal, Twill' || variation.swatch_image;
        //     // if (variation.swatch_image !== null) {
        //     //     return self.filterDuplicateSwatches(variation, self);
        //     // }
        // });
        this.swatches = [];
        for (const variation of filteredSwatches) {
            if (
                this.swatchFilter.includes(variation.swatch_image) &&
                this.previousSwatch.swatch_image === variation.swatch_image
            ) {
                this.swatches.pop();
            }
            this.swatches.push(variation);
            this.previousSwatch = variation;
        }
        this.groupSwatches();
        this.filteredVariations = this.variations.filter((variation) => {
            if (self.selectedSwatch.swatch_image) {
                return (
                    self.checkSwatchSelection(variation, self) &&
                    variation.swatch_image === self.selectedSwatch.swatch_image
                    && variation.image === self.selectedSwatch.image
                );
            }
            return self.checkSwatchSelection(variation, self);
        });

        if (
            (this.filteredVariations.length === 1 ||
                this.selectedSwatch.swatch_image) && this.filteredVariations.length > 0
        ) {
            this.priceData = {
                price: this.filteredVariations[0].price,
                wasPrice: this.filteredVariations[0].was_price,
            };
            this.setPrice.emit(this.priceData);
            this.setImage.emit(this.filteredVariations[0]);
            this.currentFilteredVariations.emit({ data: this.filteredVariations, current: this.filteredVariations[0] });

        } else {
            this.checkSwatchActive();
        }
    }

    filterVariationsForSingleSelect() {
        if (this.filteredVariations.length > 0) {
            this.filterSwatchesBasedOnValidVariations();
        }
    }

    filterSwatchesBasedOnValidVariations() {
        let excludedOptions = [];

        const variations = this.filteredVariations
            .reduce((acc, { features }) => {
                Object.keys(features).forEach((key) => {
                    if (acc[key]) {
                        if (!acc[key].includes(features[key])) {
                            acc[key].push(features[key]);
                        }
                    } else {
                        acc[key] = [features[key]];
                    }
                });
                return acc;
            }, {});

        // tslint:disable-next-line:forin
        for (const selection in this.selections) {
            const options = this.inputSelections[selection].options;
            excludedOptions = [...excludedOptions, ...options];
        }
        for (const option in this.selectionOptions) {
            if (!excludedOptions.includes(option)) {
                this.selectionOptions[option] = false;
            }
        }
        for (const value of this.filteredVariations) {
            // console.log('value ', value);

            const options = value.features;
            // console.log('options ', options);

            // tslint:disable-next-line: forin
            for (const features in options) {
                const feature = options[features];

                // console.log('feature: ', feature);
                // console.log('value.swatch_image ', value);
                // console.log('this.selectedSwatch ', this.selectedSwatch);

                if (feature && feature.charAt(0) !== '#' && features !== 'color_group') {
                    // console.log('filter feature: ', feature);
                    if (this.selectionOptions.hasOwnProperty(feature)) {
                        this.selectionOptions[feature] = true;
                    }
                }

                // console.log('this.selectionOptions[feature]: ', this.selectionOptions);
            }
        }
    }

    checkSwatchSelection(variation, self) {
        let isValidVariation = true;
        for (const key in self.selections) {
            if (this.selectionHasFeature(variation.features, key)) {
                isValidVariation = true;
            } else {
                isValidVariation = false;
                break;
            }
        }
        return isValidVariation;
    }

    /**
     * Check if selection has particular feature or not.
     * @param feature Features array
     * @param key Key to be used for comparison
     */
    selectionHasFeature(feature, key) {
        if (!isArray(this.selections[key]) && feature[key] === this.selections[key]) {
            return true;
        } else if (isArray(this.selections[key])) {
            return this.selections[key].includes(feature[key]);
        }
    }

    /**
     * Filters variations based on swatch image.
     * Swatch Image is unique across variations with multiple features
     * @param variation
     * @param self
     */
    filterDuplicateSwatches(variation, self) {
        let isValidSwatch;
        if (
            !self.swatchFilter.includes(variation.swatch_image) ||
            !self.swatchFilter.includes(variation.swatch_image) ||
            self.swatchFilter.length === 0
        ) {
            self.swatchFilter.push(variation.swatch_image);
            isValidSwatch = true;
            self.previousSwatch = variation;
        } else {
            if (
                variation.hasOwnProperty('enabled') &&
                !self.previousSwatch.enabled &&
                variation.enabled
            ) {
                isValidSwatch = true;
                self.swatchFilter.pop();
                self.swatchFilter.push(variation.swatch_image);
                self.previousSwatch = variation;
            } else {
                isValidSwatch = false;
            }
        }
        return isValidSwatch;
    }

    filterSwatches() {
        let variations = this.variations;
        if (this.selectedSwatch.name) {
            variations = this.variations.filter(variation => this.selectedSwatch.name === variation.name);
        }
        if (this.selectionsExist && this.selectedSwatch.swatch_image) {
            // tslint:disable-next-line: forin
            // for (const keys in this.selectionOptions) {
            //   this.selectionOptions[keys] = false;
            // }
            // tslint:disable-next-line: forin
            for (const key in variations) {
                const value = variations[key];
                // console.log('value ', value);

                const options = value.features;
                // console.log('options ', options);

                // tslint:disable-next-line: forin
                for (const features in options) {
                    const feature = options[features];
                    // console.log('feature: ', feature);
                    // console.log('value.swatch_image ', value);
                    // console.log('this.selectedSwatch ', this.selectedSwatch);

                    if (feature && feature.charAt(0) !== '#') {
                        // console.log('filter feature: ', feature);
                        if (
                            this.selectionOptions.hasOwnProperty(feature) &&
                            value.swatch_image === this.selectedSwatch.swatch_image
                        ) {
                            this.selectionOptions[feature] = true;
                        }
                    }
                    // console.log('this.selectionOptions[feature]: ', this.selectionOptions);
                }
            }
        } else {
            // tslint:disable-next-line: forin
            for (const keys in this.selectionOptions) {
                this.selectionOptions[keys] = true;
            }
        }
    }

    checkSwatchActive() {
        if (
            this.selectedSwatch.swatch_image &&
            this.swatches.some(
                (data) => data.swatch_image === this.selectedSwatch.swatch_image
            )
        ) {
            this.priceData = {
                price: this.filteredVariations[0].price,
                wasPrice: this.filteredVariations[0].wasPrice,
            };
            this.setPrice.emit(this.priceData);
            this.setImage.emit(this.selectedSwatch);
            this.currentFilteredVariations.emit({ data: this.filteredVariations, current: this.filteredVariations[0] });

        } else {
            this.selectedSwatch = {
                image: '',
                swatch_image: null,
                price: '',
                wasPrice: '',
                variation_sku: '',
                name: '',
            };
            this.setPrice.emit('');
            this.setImage.emit('');
            this.currentFilteredVariations.emit({ data: this.filteredVariations, current: this.filteredVariations[0] });

            this.selectedIndex = null;
        }
    }
    groupSwatches() {
        this.stockedSwatches = this.swatches.filter(f => !f.inventory_product_details || f.inventory_product_details.is_mto == '0');
        this.customMadeSwatches = this.swatches.filter(f => f.inventory_product_details && f.inventory_product_details.is_mto == '1');
    }
    get getIndex(): number {
        this.currentIndex++;
        return this.currentIndex;
    }
    get getDataAvailability(): boolean {
        return this.finalInputSelec.filter(f => f.value.select_type == 'single_select').length > 0;
    }
}

